import {Product} from './types';

export const isNotAvailable = (product: Product): boolean => {
    return product.status === null;
};

export const isAvailable = (product: Product): boolean => {
    return !isNotAvailable(product);
};

export const hasStock = (count: number): boolean => count > 0;

export const hasPrice = (price: number | null): boolean => price !== null;

export const isInStock = (product: Product) => hasStock(product.kol);

export const isOutOfStock = (product: Product) => !isInStock(product);

export type ProductAvailabilityStatus =
    | "outOfStock"
    | "lowStock"
    | "inStock";

export const getAvailabilityStatus = (count: number): ProductAvailabilityStatus => {
    if (count === 0) {
        return "outOfStock";
    }

    if (count < 3) {
        return "lowStock";
    }

    return "inStock";
};

// export const isOutOfStock = (product: Product): boolean => {
//     return product.card_price === null;
// };
//
// export const isInStock = (product: Product): boolean => {
//     return !isOutOfStock(product);
// };
